import React, { useState, useEffect } from 'react';
import { Box, Typography, TextField } from '@mui/material';
import { Check } from '@mui/icons-material';
import { usePolicyStore } from '@store/policyStore';
import { useDriverStore } from '@store/driverInfoStore';

const validCodeEmployee = [
  { name: 'ABCD', id: '1' },
  { name: 'TG34', id: '2' },
  { name: 'GHUT', id: '3' },
];

export const CollaboratorCard = () => {
  const [checkCode, setCheckCode] = useState({ message: '', isError: false });
  const [isCodeSucces, setIsCodeSucces] = useState(false);
  const { policy, addPolicyInfo } = usePolicyStore();
  const { code, setCode } = useDriverStore();

  useEffect(() => {
    if (validCodeEmployee.find((c) => c.name === code)) {
      setCheckCode({ message: '', isError: false });
      setIsCodeSucces(true);
    }
  }, [code]);

  const handleClick = (code_name: any) => {
    policy.employee_id = code_name;
    addPolicyInfo({ ...policy });
    setCode(code_name);
  };

  return (
    <Box
      marginTop={2}
      borderRadius={4}
      style={{
        padding: '15px 0px 10px 15px',
        backgroundColor: '#F2FAFC',
      }}
    >
      <Typography fontWeight={600} fontSize="14px" marginBottom={1}>
        ¡ATENCIÓN!
      </Typography>
      <Typography
        fontWeight={600}
        fontSize="14px"
        marginBottom={1}
        paddingLeft={2}
      >
        ¿Eres colaborador de inter?
      </Typography>
      <Typography fontSize="12px" marginBottom={2}>
        ¡Genial! Compártenos tu número de colaborador para que recibas todos los
        beneficios que tenemos para ti.
      </Typography>
      <TextField
        fullWidth
        label="Número de colaborador"
        value={code}
        helperText={checkCode.message}
        error={checkCode.isError}
        onChange={(e) => handleClick(e.target.value.toUpperCase().trim())}
        color={isCodeSucces ? 'success' : 'primary'}
        style={{
          maxWidth: '471px',
          borderRadius: '8px',
          marginBottom: '15px',
        }}
        InputProps={{
          style: {
            borderRadius: 8,
          },
          endAdornment: isCodeSucces ? <Check color={'success'} /> : null,
        }}
      />
    </Box>
  );
};
